import { Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class MetaService {
  
    //inject services
  constructor(private ms: Meta, private ts: Title) { }

  //updates metadata tags for SEO optimization
  updateTags(strTitle, strKeywords, strDescription) {
    //SEO Optimization
    this.ts.setTitle(strTitle);
    //remove existing tags
    this.ms.removeTag('name="keywords"');
    this.ms.removeTag('name="description"');
    //see if robot tag exists
    if (this.ms.getTag('name="robots"') == null) {
      this.ms.addTag({name: 'robots', content: 'index, follow'});
    }
    //add new tags for this page
    this.ms.addTags([
      {name: 'keywords', content: strKeywords},
      {name: 'description', content: strDescription}
    ]);
  }

}
